import script from "./CategoriesMegaMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesMegaMenu.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesMegaMenu.vue?vue&type=style&index=0&id=c875cdf0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c875cdf0"]])

export default __exports__